"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var TableMenuIsDefault_1 = require("../../../../../../shared/components/table_menus/TableMenuIsDefault");
var TableActionCopy_1 = require("../../../../../../shared/components/table_actions/TableActionCopy");
var ToolBarDateRangeFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var BonusTournamentsList = /** @class */ (function (_super) {
    __extends(BonusTournamentsList, _super);
    function BonusTournamentsList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchDescriptionInput = null;
        _this.searchTitleInput = null;
        return _this;
    }
    BonusTournamentsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            searchDescriptionFilter: [],
            searchDescriptionValue: "",
            searchTitleFilter: [],
            searchTitleValue: "",
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat(),
        }, function () {
            _this.loadData(_this.props);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    BonusTournamentsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    BonusTournamentsList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize
            }, function () {
                _this.loadData(_this.props);
            });
        }
    };
    BonusTournamentsList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadData({
            brands: this.props.brandsList,
            allBrands: this.props.allBrands,
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    BonusTournamentsList.prototype.onClearDescriptionFilter = function () {
        this.setState({ searchDescriptionFilter: [], searchDescriptionValue: "" });
    };
    BonusTournamentsList.prototype.onChangeDescriptionFilter = function (e) {
        this.setState({ searchDescriptionValue: e.target.value });
    };
    BonusTournamentsList.prototype.onConfirmDescriptionFilter = function () {
        this.setState({ searchDescriptionFilter: [this.state.searchDescriptionValue] });
    };
    BonusTournamentsList.prototype.onClearTitleFilter = function () {
        this.setState({ searchTitleFilter: [], searchTitleValue: "" });
    };
    BonusTournamentsList.prototype.onChangeTitleFilter = function (e) {
        this.setState({ searchTitleValue: e.target.value });
    };
    BonusTournamentsList.prototype.onConfirmTitleFilter = function () {
        this.setState({ searchTitleFilter: [this.state.searchTitleValue] });
    };
    BonusTournamentsList.prototype.doPublishAction = function (Key, Title, isPublished) {
        var _this = this;
        this.props.data.DoSetIsPublished(Key, isPublished, function () {
            if (isPublished) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0422\u0443\u0440\u043D\u0438\u0440 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0422\u0443\u0440\u043D\u0438\u0440 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0441\u043D\u044F\u0442 \u0441 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438"));
            }
            _this.loadData(_this.props);
        });
    };
    BonusTournamentsList.prototype.getColumns = function () {
        var _this = this;
        var _description_filter = this.state.searchDescriptionFilter;
        var _title_filter = this.state.searchTitleFilter;
        return [{
                title: 'Название',
                dataIndex: this.props.data.dk_title,
                key: this.props.data.dk_title,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchTitleInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E", value: _this.state.searchTitleValue, onChange: _this.onChangeTitleFilter.bind(_this), onPressEnter: function () { _this.onConfirmTitleFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmTitleFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearTitleFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _title_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.title.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchTitleInput.focus();
                        });
                    }
                }
            }, {
                title: 'Бренд',
                dataIndex: this.props.data.dk_brand_title,
                key: this.props.data.dk_brand_title,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.brand_title));
                },
                width: 150,
            }, {
                title: 'Тип турнира',
                dataIndex: this.props.data.dk_tournament_kind_title,
                key: this.props.data.dk_tournament_kind_title,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.tournament_kind_title));
                },
                width: 150,
            }, {
                title: 'Статус',
                dataIndex: this.props.data.dk_tournament_state_title,
                key: this.props.data.dk_tournament_state_title,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.tournament_state_title));
                },
                width: 120,
            }, {
                title: 'Набор игр',
                dataIndex: this.props.data.dk_cms_gameset_title,
                key: this.props.data.dk_cms_gameset_title,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.cms_gameset_title));
                },
                width: 150,
            }, {
                title: 'Треб. к ур.',
                dataIndex: this.props.data.dk_min_player_level_title,
                key: this.props.data.dk_min_player_level_title,
                render: function (text, record, idx) {
                    if (record.is_req_player_level) {
                        return (React.createElement("div", null, record.min_player_level_title));
                    }
                    else {
                        return (React.createElement("div", null, "\u041D\u0415\u0422"));
                    }
                },
                width: 150,
            }, {
                title: 'Треб. к деп.',
                dataIndex: this.props.data.dk_deposit_age_type_title,
                key: this.props.data.dk_deposit_age_type_title,
                render: function (text, record, idx) {
                    if (record.is_req_deposit_during_age) {
                        if (record.is_req_deposit_amount_during_age) {
                            return (React.createElement("div", null, "\u0414\u0410:$"));
                        }
                        else {
                            return (React.createElement("div", null, "\u0414\u0410"));
                        }
                    }
                    else {
                        return (React.createElement("div", null, "\u041D\u0415\u0422"));
                    }
                },
                width: 120,
            }, {
                title: 'Дата начала',
                dataIndex: this.props.data.dk_date_start,
                key: this.props.data.dk_date_start,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_start.format(_this.props.state.getDateTimeFormat())));
                },
                width: 150,
            }, {
                title: 'Дата окончания',
                dataIndex: this.props.data.dk_date_end,
                key: this.props.data.dk_date_end,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_end.format(_this.props.state.getDateTimeFormat())));
                },
                width: 150,
            }, {
                title: 'Опубликован',
                dataIndex: this.props.data.dk_is_published,
                key: this.props.data.dk_is_published,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsDefault_1.default, { defaultTexts: { menu: "Опубликовать", text: "Да" }, notDefaultTexts: { menu: "Снять с публикации", text: "Нет" }, record: { key: record.key, title: record.brand_title, isDefault: record.is_published }, onDefaultClick: _this.doPublishAction.bind(_this) }));
                },
                width: 140,
            }, {
                title: 'Комментарий',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 220,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchDescriptionInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u044E", value: _this.state.searchDescriptionValue, onChange: _this.onChangeDescriptionFilter.bind(_this), onPressEnter: function () { _this.onConfirmDescriptionFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmDescriptionFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearDescriptionFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _description_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.description.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchDescriptionInput.focus();
                        });
                    }
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditGameSetClick(record); } }),
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onConfigGameSetClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }),
                    React.createElement(TableActionCopy_1.default, { hint: "Клонировать", confirmText: "\u041A\u043B\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onCloneData(record); } }))); },
                width: 100
            }];
    };
    BonusTournamentsList.prototype.onCloneData = function (record) {
        var _this = this;
        this.props.data.DoCloneTournament(record.key, function () {
            _this.loadData(_this.props);
        });
    };
    BonusTournamentsList.prototype.onEditGameSetClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BonusTournamentsList.prototype.onConfigGameSetClick = function (record) {
        if (this.props.onConfigClick) {
            this.props.onConfigClick(record);
        }
    };
    BonusTournamentsList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0444\u0440\u0438\u0441\u043F\u0438\u043D\u043E\u0432 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    BonusTournamentsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.loadData(_this.props, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, _PageSize);
                }
            });
        });
    };
    BonusTournamentsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    BonusTournamentsList.prototype.OnBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    BonusTournamentsList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    BonusTournamentsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) }),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.OnBrandFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed.format(_this.props.state.getDateTimeFormat()),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041D\u0430\u0447\u0430\u043B\u043E:"),
                            " [",
                            record.date_start.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0435:"),
                            " [",
                            record.date_end.format(_this.props.state.getDateTimeFormat()),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435:"),
                            " [",
                            record.description,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u043F\u0440\u0438\u0437\u043E\u0432\u044B\u0445 \u043C\u0435\u0441\u0442:"),
                            " [",
                            record.number_of_prizes,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u0444\u0440\u0438\u0441\u043F\u0438\u043D\u043E\u0432:"),
                            " [",
                            record.freespin_count,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u043F\u043E\u043F\u044B\u0442\u043E\u043A:"),
                            " [",
                            record.max_buys_count,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u043F\u043E\u043F\u044B\u0442\u043E\u043A \u043D\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D:"),
                            " [",
                            record.is_unlimited_buys_count,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0412\u0430\u043B\u044E\u0442\u0430 \u0442\u0443\u0440\u043D\u0438\u0440\u0430:"),
                            " [",
                            record.app_currency_title,
                            "]")));
                }, scroll: { x: true } })));
    };
    return BonusTournamentsList;
}(React.Component));
exports.default = BonusTournamentsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/BonusTournamentsList.tsx
// module id = 2502
// module chunks = 0